import Modal from 'react-bootstrap/Modal'
import AuthContext from "../AuthProvider"
import { useContext } from "react"
import { useNavigate } from 'react-router-dom';

function LogoutModal(props) {
  const navigate = useNavigate(); 
  const {setUser} = useContext(AuthContext);

  const handleLogout = (e) => {
    setUser(null);
    navigate('/')
  }
  
  return (
    <Modal
    {...props}
    size="md"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
    <h6 className='del-head'>Log Out Account</h6>
    </Modal.Header>
    <Modal.Body >
     <div className="del-body logout">
      <p className='del-text'>Are you sure you want to log out this account?</p>

      <div className="lgt-btn-group">
       <div className="no" onClick={()=> props.onHide()}>No</div>
       <div className="yes" onClick={handleLogout}>Yes</div>
      </div>
     </div>
       
    </Modal.Body>
  </Modal>
  )
}

export default LogoutModal